import React, { useState } from 'react';

function ChatMessage({ message, onUpdate, onDelete }) {
  // 수정 모드 여부
  const [isEditing, setIsEditing] = useState(false);
  // 수정 중인 텍스트
  const [editedText, setEditedText] = useState(message.text);

  // 수정 버튼
  const handleEdit = () => {
    setIsEditing(true);
  };
  // 저장 버튼
  const handleSave = () => {
    onUpdate(message.id, editedText);
    setIsEditing(false);
  };

  // 삭제 버튼
  const handleDelete = () => {
    onDelete(message.id);
  };

  // role에 따라 좌우 정렬
  const isMyMessage = (message.sender === "내 메시지");
  // 오른쪽 정렬: 내 메시지 / 왼쪽 정렬: 상대방 메시지
  const containerClass = isMyMessage ? "justify-end" : "justify-start";

  return (
    <div className={`flex ${containerClass} mb-2`}>
      <div className="max-w-[70%] p-2 border border-gray-300 rounded">
        {isEditing ? (
          <input
            type="text"
            value={editedText}
            onChange={(e) => setEditedText(e.target.value)}
            className="w-full p-1 border rounded"
          />
        ) : (
          <p>{message.text}</p>
        )}
        <div className="mt-1 flex justify-end space-x-2">
          {isEditing ? (
            <button onClick={handleSave} className="text-blue-500 text-sm">
              저장
            </button>
          ) : (
            <button onClick={handleEdit} className="text-blue-500 text-sm">
              수정
            </button>
          )}
          <button onClick={handleDelete} className="text-red-500 text-sm">
            삭제
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChatMessage;
